export default "__VITE_ASSET__CE$k2eRD__"